module.exports = __webpack_public_path__ + "img/IT0000113003087.738ee0a5.png";